import { useEffect } from "react";

const DEFAULT_MESSAGE =
  "An EEG upload is in progress. Leaving this page may interrupt the transfer.";

export function useUploadBeforeUnload(
  enabled: boolean,
  message: string = DEFAULT_MESSAGE,
): void {
  useEffect(() => {
    if (!enabled || typeof window === "undefined") return undefined;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = message;
      return message;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [enabled, message]);
}
